const btnFind = document.querySelector('.aaa-gift-find');
const btnCreate = document.querySelector('.aaa-gift-create');
const btnManage = document.querySelector('.aaa-gift-manage');
const myRegistry = document.querySelector('#aaa-registry-products-form .update_cart_bottom_fix .btn_wrapper');

const login = window.ShopifyAnalytics.meta.page.customerId;

function goToAnchor() {
  document.getElementById("aaa-gift-response").scrollIntoView();
}

function goToResponse(btn) {
    if (btn !== btnFind) {
        if (login !== '') {
            goToAnchor();
        }
    } else {
        goToAnchor();
    }
}

btnFind.addEventListener("click", () => { goToResponse(this); });
btnCreate.addEventListener("click", () => { goToResponse(this); });
btnManage.addEventListener("click", () => { goToResponse(this); });

// Translate registry product name in app page

// function appTranslate() {
//   const registryPage = document.querySelector(".registry_products_table_responsive");
//   if (registryPage) {
//
//     const translateContent = function(el) {
//       const langSelector = document.querySelector(".language-selector.hide");
//       const lang = langSelector.getAttribute("data-lang");
//
//       const pattern = "||";
//       const index = (lang == "fr") ? 0 : 1;
//       console.log(index);
//       let textNode, walk = document.createTreeWalker(el,NodeFilter.SHOW_TEXT,null,false);
//       while (textNode = walk.nextNode()) {
//         const string = textNode.wholeText;
//         if (string.includes(pattern)) {
//           textNode.nodeValue = string.split(pattern)[index];
//         }
//       };
//     }
//
//     translateContent(registryPage);
//
//     const registryCallback = function(mutations, observer) {
//       mutations.forEach(mutation => {
//         mutation.addedNodes.forEach(node => {
//           if (node.nodeType == 1) {
//             translateContent(node);
//           };
//         });
//       });
//     };
//
//     const registryObserver = new MutationObserver(registryCallback);
//     registryObserver.observe(registryPage, { childList: true, subtree: true });
//   }
// }
//
// // Remove bug Modal backdrop
// const bodyTag =  document.body;
//
// const backdrop = document.querySelectorAll('.modal-backdrop')
//
// function removeElementsByClass(className){
//   const elements = document.getElementsByClassName(className);
//   while(elements.length > 0){
//     elements[0].parentNode.removeChild(elements[0]);
//   }
// }
var currentUserId = window.cffCustomer.id;
var cookieUserRegistryId = "aaa_registry_gift_customer";

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

if (currentUserId !== "") {
  if(currentUserId === getCookie(cookieUserRegistryId) ) {
    if (myRegistry) {
        var viewProductsLink = document.createElement("a");
        var linkLabel = document.createTextNode("Ajouter des articles||Add items");
        viewProductsLink.appendChild(linkLabel);
        viewProductsLink.href = "/collections/liste-de-naissance";
        viewProductsLink.classList.add("btn");
        viewProductsLink.setAttribute("id", "add_products_to_list");
        myRegistry.appendChild(viewProductsLink);
    }
  }
}


